import type { ReactNode } from "react";
import { useCan } from "../auth/useCan.js";
import type { Permission } from "../types.js";

/**
 * Render children only when the current user may perform `permission` — via the
 * combined `useCan` check (global platform permission OR the selected org's role
 * grants it). Mirrors the API's authorize + authorizeOrg split so an org admin
 * who holds no global permissions still sees their org-scoped controls.
 */
export function RequirePermission({ permission, children }: { permission: Permission; children: ReactNode }) {
  const can = useCan();
  return can(permission) ? <>{children}</> : null;
}
